module.exports = __webpack_public_path__ + "media/npc_dota_hero_primal_beast.fc021097.webm";